import React, { useContext } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import { AuthContext } from '../reducers/Auth/AuthContext';

const Bell = ({ active }) => {
  if (active) {
    return (
      <div className="p-abs p-top-right">
        <NotificationsIcon className="txt-white s-16-i p-4" />
      </div>
    );
  }

  return (
    <div className="p-abs p-top-left">
      <NotificationsOffIcon className="s-16-i txt-white p-4" />
    </div>
  );
};

const PointCard = (props) => {
  const {
    point: { pointId, assignee, type },
    selected,
  } = props;

  const [placeState] = useContext(PlaceStoreContext);
  const {
    users: { userId__user },
  } = placeState;
  const [authState] = useContext(AuthContext);
  const {
    user: { placeId, userId },
  } = authState;

  const username = assignee ? userId__user?.[assignee] : null;
  const isUsersPoint = assignee === userId;
  const isOtherUserPoint = assignee && !isUsersPoint;

  let background = 'bg-grey';
  let assignedTextColor = 'txt-white';
  let fontStyle = 'f3';
  if (isUsersPoint) {
    background = 'bg-yellow';
    fontStyle = 'f3b';
    assignedTextColor = 'txt-black';
  } else if (username?.name) {
    background = 'bg-assigned';
    assignedTextColor = 'txt-warning';
    fontStyle = 'f3b';
  }

  if (selected) {
    background = 'bg-pink';
    assignedTextColor = 'txt-white';
  }

  return (
    <div
      className={`p-rel f-c f-dirc br-2 m-4 ${background} fds-2`}
      style={{
        opacity: isOtherUserPoint ? 0.5 : 1,
      }}
    >
      <div
        className="f3b ta-c txt-white pt-32 pr-32 pl-32 pb-8"
        style={{
          fontSize: 'calc(24px + 2vw)',
          lineHeight: '16px',
        }}
      >
        {type !== 'default' ? type.toUpperCase() : pointId}
      </div>
      <div className={`f10 f2b ${assignedTextColor} ta-c mt-16 mb-4 p-8`}>
        {type !== 'default' ? pointId : '...'}
      </div>
      <div
        className={`${fontStyle} ta-c ${assignedTextColor} pb-8`}
        style={{
          fontSize: 'calc(8px + 0.32vw)',
          lineHeight: '8px',
          marginTop: '-8px',
        }}
      >
        {username?.name || 'ACTIVE'}
      </div>
      <Bell active={!(assignee || isOtherUserPoint)} />
    </div>
  );
};

export { PointCard };
